import { Injectable } from "@angular/core";
import { NavigationHierarchyService } from "@common/route/navigation-hierarchy.service";
import { SidebarTabIconComponent } from "@common/shell/sidebar-tab-icon/sidebar-tab-icon.component";
import { IComponentRender } from "@common/ux/render-component/component-render.interface";
import { AuthorisationNotificationService } from "@org-common/lib/authorisation/authorisation-notification.service";
import { OrganisationService } from "@org-common/lib/organisation/organisation.service";
import { OrgCommonNavigationTab } from "@org-common/lib/sidebar/org-common-navigation-tab";
import { CommonTeamsService } from "@org-common/lib/teams/common-teams.service";
import { startWith, switchMap } from "rxjs/operators";
import { OwnerHierarchyNavigationService } from "../../../platform/navigation/owner-hierarchy-navigation.service";
import { OwnerTabContentComponent } from "./owner-tab-content.component";

@Injectable()
export class OwnerTab extends OrgCommonNavigationTab {
    public id = "sidebar-owner";
    public label = "Personal";
    public ordinal = 3;

    public icon: IComponentRender<SidebarTabIconComponent> = {
        component: SidebarTabIconComponent,
        params: {
            iconClass: OwnerHierarchyNavigationService.IconClass,
            iconText: "Owner",
        },
    };

    public content: IComponentRender<OwnerTabContentComponent> = {
        component: OwnerTabContentComponent,
    };

    public constructor(
        authorisationNotificationService: AuthorisationNotificationService,
        navigationHierarchyService: NavigationHierarchyService,
        organisationService: OrganisationService,
        teamsService: CommonTeamsService,
    ) {
        super(navigationHierarchyService, organisationService);

        // We need to check on this event as this is where the connections are
        // primed which person.isActive checks against
        this.isDisplayed$ = authorisationNotificationService.authorisationChanged$.pipe(
            startWith(undefined),
            switchMap(() => teamsService.canAccessOwnerTab()),
        );
    }

    protected getHierarchyId(): string {
        return OwnerHierarchyNavigationService.HierarchyId;
    }
}
